/**
 * Создает обертку над функцией, которая вызывает исходную функцию спустя `waitMs` миллисекунд после последнего
 * вызова функции-обертки.
 *
 * @param fn Функция для дебаунса
 * @param waitMs Количество миллисекунд до вызова функции (должно быть положительным числом)
 * @typeParam Fn Тип функции
 * @returns Функция-обертка. Функция содержит метод `cancel`, позволяющий отменить отложенный вызов исходной функции
 * @example
 * ```ts
 * // Дебаунс функции поиска
 * const search = debounce((query: string) => {
 *   console.log(`Searching for: ${query}`);
 * }, 300);
 *
 * // Вызовы с быстрым интервалом - функция выполнится только один раз
 * search('a');
 * search('ab');
 * search('abc'); // Только этот вызов выполнится через 300мс
 *
 * // Отмена отложенного вызова
 * search.cancel();
 *
 * // Дебаунс обработчика ввода в поле поиска
 * const searchInput = document.getElementById('search');
 * const handleSearch = debounce((event: Event) => {
 *   const query = (event.target as HTMLInputElement).value;
 *   fetchResults(query);
 * }, 500);
 *
 * searchInput.addEventListener('input', handleSearch);
 * ```
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- any требуется в extends
export function debounce(fn, waitMs) {
    let interval;
    function debouncedFn(...args) {
        clearInterval(interval);
        interval = setTimeout(() => {
            fn(...args);
        }, waitMs);
    }
    Object.assign(debouncedFn, {
        cancel() {
            clearInterval(interval);
        },
    });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- DIRECT-239681
    return debouncedFn;
}
